import { WeighbillType } from "../types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

// Fetch all weighbills
export const getWeighBills = async () => {
  return axios
    .get(ServiceEndpoints.WEIGHBILL)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new weighbill
export const createWeighBill = async (data: FormData) => {
  return axios
    .post(ServiceEndpoints.WEIGHBILL, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update a weighbill by ID
export const updateWeighBill = async (id: string, data: WeighbillType) => {
  const { ...weighbillData } = data;

  return axios
    .put(`${ServiceEndpoints.WEIGHBILL}/${id}`, weighbillData)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update a weighbill status by ID
export const updateWeighBillStatus = async (
  id: string,
  data: { status: string }
) => {
  const { ...weighbillData } = data;

  return axios
    .patch(
      `${ServiceEndpoints.WEIGHBILL}/${id}/status?status=${weighbillData.status}`
    )
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get a weighbill by its ID
export const getWeighBillById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.WEIGHBILL}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete a weighbill by ID
export const deleteWeighBill = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.WEIGHBILL}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
